/* stylelint-disable declaration-block-single-line-max-declarations */

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { keyframes } from 'styled-components';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { media } from '../media';

// QuoteBanner styles

export const BannerContentWrapper = styled.div({
  color: token('color.text.inverse', colors.N0),
  display: 'flex',
  whiteSpace: 'nowrap',
  alignItems: 'center',
  p: {
    margin: `0 0 0 ${token('space.100', '8px')}`,
  },
  a: {
    color: token('color.text.inverse', colors.N0),
  },
});

// PipelineCard styles
export const PipelineCardWrapper = styled.div({
  width: '100%',
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'center',
  alignItems: 'center',
});

export const PipelineCardContent = styled.div(
  {
    marginLeft: '50px',
  },
  media.smallScreen`
		margin: 0;
		padding-top: 5%;
	`,
  {
    h1: {
      font: token('font.heading.medium'),
      fontWeight: token('font.weight.semibold'),
    },
    h3: {
      font: token('font.body'),
      a: {
        padding: '0px',
        margin: '0 0 3px 0',
      },
    },
    'h3 + h3': {
      marginTop: token('space.100', '8px'),
    },
  }
);

export const StyledPipeline = styled.img({
  height: '183px',
  width: '351px',
});

// PipesCard styles
export const PipesCardWrapper = styled.div({
  width: '100%',
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'center',
  marginTop: '50px',
  alignItems: 'center',
});

export const PipesCardContent = styled.div(
  {
    marginRight: '50px',
  },
  media.smallScreen`
		margin-left: 0;
	`,
  {
    h1: {
      font: token('font.heading.medium'),
      fontWeight: token('font.weight.semibold'),
    },
    h3: {
      font: token('font.body'),
    },
    'h3 + h3': {
      marginTop: token('space.100', '8px'),
    },
  }
);

export const StyledPipes = styled.img(
  media.smallScreen`
		padding-top: 5%;
	`,
  {
    height: '221px',
    width: '273px',
  }
);

// Header styles
export const HeaderWrapper = styled.div({
  width: '100%',
  textAlign: 'center',
  margin: `${token('space.100', '8px')} auto 0 auto`,
  position: 'relative',
  h1: {
    font: token('font.heading.medium'),
    fontWeight: token('font.weight.semibold'),
    marginTop: '34px',
  },
  h3: {
    font: token('font.body'),
    marginTop: token('space.100', '8px'),
  },
});

export const StyledFileStorage = styled.img({
  alignItems: 'center',
  textAlign: 'center',
  display: 'flex',
  height: '115px',
  width: '134px',
  margin: '90px auto 0px auto',
});

// Onboarding styles
export const ScrollWrapper = styled.div({
  height: '100vh',
  scrollBehavior: 'smooth',
  margin: token('space.negative.250', '-20px'),
  h1: {
    font: token('font.heading.medium'),
  },
  h3: {
    fontWeight: token('font.weight.regular'),
    marginTop: token('space.300', '24px'),
  },
});

export const ValuePropContainer = styled.div(
  {
    marginTop: '-3%',
    paddingLeft: '10%',
    paddingRight: '10%',
  },
  media.smallScreen`
		padding-left: 5%;
		padding-right: 5%;
	`
);

export const CreatePipelineAction = styled.div({
  padding: `${token('space.300', '24px')} 0 54px`,
  height: '45px',
  width: '100%',
  margin: 'auto',
  textAlign: 'center',
  color: token('color.text.information', colors.B400),
  p: {
    height: '32px',
    textAlign: 'center',
    position: 'relative',
    width: '200px',
    margin: '0 auto',
  },
});

export const ArrowWrapper = styled.div({
  textAlign: 'center',
  marginTop: token('space.100', '8px'),
});

export const TemplatesWrapper = styled.div({
  maxWidth: '870px',
  margin: `${token('space.400', '32px')} auto 54px`,
  padding: `0 ${token('space.400', '32px')}`,
});

export const RecommendedTemplate = styled.div({
  borderTop: `1px solid ${token('color.border', colors.N40)}`,
  maxWidth: '777px',
  padding: `${token('space.400', '32px')} 0`,
  margin: '0 auto',
  '& > h3': {
    textAlign: 'center',
    marginBottom: '28px',
    fontWeight: token('font.weight.medium'),
    color: token('color.text', 'black'),
  },
  '& > p': {
    textAlign: 'center',
    fontWeight: token('font.weight.semibold'),
    color: token('color.text', 'black'),
    '& > span': {
      marginLeft: token('space.100', '8px'),
    },
  },
});

export const ChooseTemplatesMessage = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `0 ${token('space.200', '16px')}`,
  '& > p': {
    fontWeight: token('font.weight.semibold'),
    color: token('color.text', 'black'),
  },
});

export const TemplateList = styled.div({
  display: 'flex',
  justifyContent: 'center',
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression
export const TemplateCard = styled.div<{ isRecommendedTemplate: boolean }>`
  width: 257px;
  height: 128px;
  border-radius: 4px;
  margin: ${token('space.200', '16px')};
  box-shadow: ${token(
    'elevation.shadow.raised',
    `0 1px 1px ${colors.N50A}, 0 0 1px 1px ${colors.N40A}`
  )};
  header {
    background-color: ${props =>
      props.isRecommendedTemplate
        ? token('color.background.neutral.bold', colors.N400)
        : token('color.background.neutral', colors.N40)};
    display: flex;
    height: 48px;
    padding: 0 ${token('space.100', '8px')} 0 ${token('space.200', '16px')};
    align-items: center;
    justify-content: space-between;
    color: ${token('color.text.inverse', colors.N0)};
    border-radius: 4px 4px 0 0;
  }
  article {
    padding: ${token('space.100', '8px')} ${token('space.200', '16px')};
    h4 {
      margin-bottom: ${token('space.100', '8px')};
    }
    p {
      color: ${token('color.text.subtlest', colors.N300)};
      font: ${token('font.body.small')};
      margin: 0;
    }
  }
`;

export const TemplateLogo = styled.div({
  width: '100px',
  height: '32px',
  backgroundSize: '64px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '0 50%',
});

export const templateButtonTheme = (isRecommendedTemplate: boolean) => {
  return {
    subtle: {
      background: {
        hover: {
          light: isRecommendedTemplate
            ? token('color.text.subtlest', colors.N200)
            : token('color.background.input.hovered', colors.N20),
        },
      },
      color: isRecommendedTemplate
        ? token('color.text.inverse', colors.N0)
        : token('color.text', colors.N800),
    },
  };
};

// ExistingConfigSection styles
export const ExistingConfigWrapper = styled.div({
  textAlign: 'center',
  p: {
    margin: `${token('space.100', '8px')} 0 ${token('space.400', '32px')}`,
  },
});

// DeploymentsOnboarding styles
export const DeploymentsWrapper = styled.div({
  margin: '50px auto',
  h3: {
    font: token('font.heading.medium'),
    marginBottom: token('space.300', '24px'),
  },
  strong: {
    fontWeight: token('font.weight.medium'),
  },
  ol: {
    textAlign: 'left',
  },
});

export const Center = styled.div({
  textAlign: 'center',
  p: {
    margin: `${token('space.150', '12px')} auto`,
    width: '500px',
  },
});

export const Loading = styled.div`
  width: 100%;
  animation: fadein 0.25s ease-out;
  text-align: center !important;
  padding: 25px 0 25px !important;
`;

export const PlanInfo = styled.span({
  a: {
    color: 'currentColor',
    fontWeight: token('font.weight.medium'),
  },
});

export const StyledDeployments = styled.img({
  width: '189px',
  height: '167px',
});

// CommitSection styles
export const CommitSectionWrapper = styled.div({
  border: `1px ${token('color.border', colors.N40)} solid`,
  borderRadius: '3px',
  padding: token('space.300', '24px'),
  marginTop: token('space.300', '24px'),
  display: 'flex',
  alignItems: 'center',
});

export const CommitButton = styled.div({
  textAlign: 'right',
  display: 'flex',
  alignItems: 'center',
});

export const ValidationMessage = styled.div({
  width: '480px',
  paddingLeft: '30px',
  position: 'relative',
  flex: '1 0 auto',
  span: {
    position: 'absolute',
    left: 0,
    top: '1px',
  },
  h5: {
    color: token('color.text', colors.N800),
    margin: 0,
  },
  p: {
    marginTop: token('space.100', '8px'),
    marginBottom: 0,
  },
  em: {
    font: token('font.body.UNSAFE_small'),
    fontFamily: token(
      'font.family.code',
      'Monaco, "Courier New", Courier, monospace'
    ),
    background: token('color.background.neutral.hovered', colors.N30),
    borderRadius: '2px',
    paddingBlock: token('space.025'),
    paddingInline: token('space.050'),
    display: 'inline-block',
  },
});

export const ValidationEmoji = styled.div({
  height: '100%',
  font: token('font.heading.medium'),
});

export const LearnMore = styled.div({
  margin: '0 10px',
});

// Editor styles
export const EditorHeader = styled.header({
  width: '100%',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  background: token('color.background.input', colors.N20),
  border: `1px solid ${token('color.border', colors.N40)}`,
  borderBottom: 0,
  borderRadius: '3px 3px 0 0',
  padding: `0 ${token('space.200', '16px')}`,
  strong: {
    marginRight: token('space.150', '12px'),
  },
});

export const EditorWrapper = styled.div({
  border: `1px solid ${token('color.border', colors.N40)}`,
});

export const EditorContainer = styled.div({
  display: 'flex',
  maxWidth: 'calc(100vw - 200px)',
  minWidth: '1000px',
  margin: '0 auto',
  flexWrap: 'wrap',
  '& > div': {
    width: '100%',
  },
});

// WaitingForDeployments styles
export const boatmove = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  '0%': {
    top: 1,
    left: '1px',
    transform: 'rotate(0deg)',
  },
  '18%': {
    transform: 'rotate(2deg)',
  },
  '25%': {
    left: '-3px',
    transform: 'rotate(3deg)',
  },
  '50%': {
    top: '8px',
  },
  '75%': {
    left: '3px',
    transform: 'rotate(-3deg)',
  },
  '85%': {
    transform: 'rotate(-2deg)',
  },
  '100%': {
    top: '1px',
    left: '1px',
    transform: 'rotate(0deg)',
  },
});

export const waves = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  '0%': {
    left: 0,
  },
  '100%': {
    left: '-106px',
  },
});

export const smoke = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  '0%': {
    width: '65px',
  },
  '50%': {
    width: '100px',
  },
  '100%': {
    width: '65px',
  },
});

export const smokeCrud1 = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  '0%': {
    left: '80px',
    opacity: 1,
    transform: 'scale(1)',
  },
  '100%': {
    left: '1px',
    opacity: 0.01,
    transform: 'scale(0.5)',
  },
});

export const smokeCrud2 = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  '0%': {
    left: '50px',
    opacity: 0.5,
    transform: 'scale(1)',
  },
  '100%': {
    left: '-20px',
    opacity: 0.01,
    transform: 'scale(0.7)',
  },
});

export const Animation = styled.div({
  position: 'relative',
  top: '27px',
  margin: 'auto',
  width: '200px',
  height: '172px',
  left: '10px',
});

export const Boat = styled.div({
  width: '178px',
  height: '141px',
  position: 'relative',
  backgroundSize: 'cover',
  top: '1px',
  left: '1px',
  animation: `${boatmove} 1500ms linear infinite`,
  zIndex: 4,
});

export const Wave = styled.div({
  width: '280px',
  height: '24px',
  position: 'absolute',
  backgroundSize: 'repeat-x',
  top: '135px',
  left: '13px',
  animation: `${waves} 5s linear infinite`,
  zIndex: 5,
});

export const SmokeStart = styled.div({
  width: '56px',
  height: '31px',
  position: 'absolute',
  backgroundSize: 'cover',
  top: '-15px',
  left: '60px',
  zIndex: 1,
});

export const SmokeEnd = styled.div({
  width: '65px',
  height: '43px',
  position: 'absolute',
  backgroundSize: '100%',
  top: '-25px',
  right: '138px',
  zIndex: 1,
  animation: `${smoke} 3s linear infinite`,
});

export const Crud1 = styled.div({
  width: '16px',
  height: '10px',
  position: 'absolute',
  backgroundSize: 'cover',
  top: '-5px',
  left: token('space.1000', '80px'),
  zIndex: 2,
  opacity: 1,
  animation: `${smokeCrud1} 2s linear infinite`,
});

export const Crud2 = styled.div({
  width: '11px',
  height: '7px',
  position: 'absolute',
  backgroundSize: 'cover',
  top: '-13px',
  left: '50px',
  zIndex: 2,
  opacity: 1,
  animation: `${smokeCrud2} 1.5s linear infinite`,
});

export const WaitingForDeploymentsWrapper = styled.div({
  width: '980px',
  margin: '50px auto',
  h3: {
    font: token('font.heading.medium'),
    marginBottom: token('space.300', '24px'),
  },
  strong: {
    fontWeight: token('font.weight.medium'),
  },
  ol: {
    textAlign: 'left',
  },
});

export const WaitingForDeploymentsCenter = styled.div({
  textAlign: 'center',
  p: {
    margin: `${token('space.150', '12px')} auto`,
    width: '600px',
  },
});
